var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c(
          "h1",
          [
            _vm._v("\n        Bookings\n        "),
            _vm.client
              ? _c("span", [_vm._v("– " + _vm._s(_vm.client.name))])
              : _vm._e(),
            _vm._v(" "),
            _vm.manager
              ? _c("span", [_vm._v("– " + _vm._s(_vm.manager.company))])
              : _vm._e(),
            _vm._v(" "),
            !_vm.$vlastMode
              ? _c("help-link", { attrs: { anchor: "bookings" } })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _c("div", { staticClass: "dashboard-results-details" }, [
          _c(
            "div",
            { staticClass: "w-full flex flex-wrap justify-between spacer-b-2" },
            [
              _c("div", { staticClass: "count" }, [
                _c("span", [_vm._v(_vm._s(_vm.pagination.total))]),
                _vm._v(" Bookings"),
              ]),
              _vm._v(" "),
              _c("booking-list-sort", {
                attrs: {
                  "set-filter-mutation": _vm.setFilter,
                  filters: _vm.filters,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "booking-list-filters",
          {
            attrs: {
              "set-filter-mutation": _vm.setFilter,
              filters: _vm.filters,
              "apply-filters": _vm.handleApplyFiltersCallback,
            },
          },
          [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-primary pull-right",
                attrs: {
                  slot: "button",
                  click: _vm.handleApplyFiltersCallback,
                  type: "submit",
                  disabled: _vm.$userIsInactiveManager,
                },
                slot: "button",
              },
              [_vm._v("\n        Search\n      ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dashboard-block" },
          [
            _c(
              "ul",
              { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
              [
                _c(
                  "li",
                  { class: { active: _vm.status === "active" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            params: { status: "active" },
                            query: _vm.$route.query,
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$userIsAdmin ||
                              _vm.$userIsIntern ||
                              this.$user.role === "sales"
                              ? "View All (Active)"
                              : "Active"
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$userIsAdmin ||
                _vm.$userIsIntern ||
                this.$user.role === "sales"
                  ? _c(
                      "li",
                      { class: { active: _vm.status === "event" } },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                params: { status: "event" },
                                query: _vm.$route.query,
                              },
                            },
                          },
                          [_vm._v("In Person")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin ||
                _vm.$userIsIntern ||
                this.$user.role === "sales"
                  ? _c(
                      "li",
                      { class: { active: _vm.status === "campaign" } },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                params: { status: "campaign" },
                                query: _vm.$route.query,
                              },
                            },
                          },
                          [_vm._v("Online")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$vlastMode &&
                _vm.$offersModuleEnabled &&
                (_vm.$userIsAdmin || _vm.$userIsManager || _vm.$userIsTalent)
                  ? _c(
                      "li",
                      { class: { active: _vm.status === "offer" } },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                params: { status: "offer" },
                                query: _vm.$route.query,
                              },
                            },
                          },
                          [_vm._v("Offer")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin ||
                _vm.$userIsIntern ||
                this.$user.role === "sales"
                  ? _c(
                      "li",
                      { class: { active: _vm.status === "completed-event" } },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                params: { status: "completed-event" },
                                query: _vm.$route.query,
                              },
                            },
                          },
                          [_vm._v("Completed (In Person)")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin ||
                _vm.$userIsIntern ||
                this.$user.role === "sales"
                  ? _c(
                      "li",
                      {
                        class: { active: _vm.status === "completed-campaign" },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                params: { status: "completed-campaign" },
                                query: _vm.$route.query,
                              },
                            },
                          },
                          [_vm._v("Completed (Online)")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$vlastMode && (_vm.$userIsAdmin || _vm.$userIsIntern)
                  ? _c(
                      "li",
                      { class: { active: _vm.status === "packages" } },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                params: { status: "packages" },
                                query: _vm.$route.query,
                              },
                            },
                          },
                          [_vm._v("Packages")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  { class: { active: _vm.status === "archived" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            params: { status: "archived" },
                            query: _vm.$route.query,
                          },
                        },
                      },
                      [_vm._v("Archived")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _vm.fetchingBookings
              ? _c("pickstar-loading", { staticClass: "m-t-lg" })
              : [
                  _vm.$userIsInactiveManager
                    ? _c("no-results", { staticClass: "text-center" }, [
                        _c(
                          "div",
                          [
                            _vm._v(
                              "\n            You will be able to view " +
                                _vm._s(_vm.$t("bookings")) +
                                " once " +
                                _vm._s(_vm.clientName) +
                                " has approved your account. In the meantime,\n            build out your "
                            ),
                            _c(
                              "router-link",
                              { attrs: { to: { name: "profile.show" } } },
                              [_vm._v("profile")]
                            ),
                            _vm._v(" or start\n            "),
                            _c(
                              "router-link",
                              { attrs: { to: { name: "talent.index" } } },
                              [
                                _vm._v(
                                  "adding your " +
                                    _vm._s(_vm.$starLabelPlural) +
                                    " for review!"
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm.haveNoBookings
                    ? _c("no-results", [
                        _c("div", [_vm._v("There are no bookings.")]),
                        _vm._v(" "),
                        _vm.haveAppliedFilters
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-default btn-sm m-t-sm",
                                on: { click: _vm.handleResetFiltersCallback },
                              },
                              [_vm._v("Reset Filters")]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-items" },
                    _vm._l(_vm.bookings, function (booking) {
                      return _c("booking-list-item", {
                        key: booking.id,
                        attrs: { booking: booking },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  !_vm.$userIsInactiveManager
                    ? _c(
                        "lazy-loading",
                        {
                          ref: "lazyLoading",
                          staticClass: "text-center",
                          attrs: {
                            loading: _vm.loading,
                            "reached-bottom": _vm.handleGetNextBookingsCallback,
                          },
                        },
                        [
                          _c("pickstar-loading", {
                            attrs: { slot: "loading" },
                            slot: "loading",
                          }),
                          _vm._v(" "),
                          _c("span", {
                            attrs: { slot: "finished" },
                            slot: "finished",
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }